export default __webpack_public_path__ + "static/media/huma-hyperchaotic-cover.86c5bd94.jpg";